var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplogieLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "246px",
    height: "54px",
    viewBox: "0 0 246 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "applogie_logo_horizontal_blue-bkgd") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_Arrangement_full-color",
    transform: "translate(-45.000000, -120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "applogie_logo_horizontal_blue-bkgd",
    transform: "translate(45.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-/-full-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-8",
    transform: "translate(27.000000, 27.000000) scale(-1, 1) translate(-27.000000, -27.000000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-5",
    fill: "#00909B",
    points: "18 0 36 0 27 18"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-5-Copy-4",
    fill: "#00BC96",
    points: "0 36 18 36 9 54"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-5-Copy-2",
    fill: "#00909B",
    points: "36 36 54 36 45 54"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1",
    fill: "#134873",
    points: "36 0 27 17.99925 36 36 54 36"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1-Copy",
    fill: "#12BEDA",
    points: "18 36 27 54 45 54 36 36"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1",
    fill: "#008F70",
    transform: "translate(13.500000, 27.000000) scale(-1, 1) translate(-13.500000, -27.000000) ",
    points: "0 18 9 36 27 36 18 18"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "applogie_wordmark_white",
    fontFamily: "AXIS, Avenir",
    fontSize: 24,
    fontWeight: 600,
    letterSpacing: 5.33333349,
    fill: "#091231"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 81.8829651,
    y: 36
  }, "APPLOGIE")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplogieLogoBlack);
export default __webpack_public_path__ + "static/media/applogie-logo-black.c14e1739edecd76e3da30c3053a8ebe1.svg";
export { ForwardRef as ReactComponent };